/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import { ContactCard } from 'C4';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ContactGroup = ({
  isGroupedContact, office, salesRegion, adressLines, telephone, contacts, region = '',
}) => (
  <Fragment>
    {!isGroupedContact && (
      <div className="contactsHeader">
        <h1>Sales - {salesRegion}</h1>
        <p>
          {adressLines.map(line => (
            <Fragment key={Math.ceil(Math.random() * 100000)}>
              {line}
              <br />
            </Fragment>
            ))}
        </p>
        {/* {!contacts && <p>Contacts array not present</p>}
          {contacts && <p>Contacts Array present. </p>} */}
      </div>
    )}
    {contacts.map(contact => (
      <ContactCard
        isGroupedContact={isGroupedContact}
        name={contact.name}
        description={contact.description}
        telephone={contact.telephone}
        mail={contact.mail}
        imageUrl={contact.imageUrl}
        town={office}
        region={contact.region}
      />
      ))}
    {isGroupedContact && (
    <div className="contactsHeader grouped">
      <h1>Sales - {salesRegion}</h1>
      {adressLines.length > 0 && (
        <p>
          {adressLines.map(line => (
            <Fragment key={Math.ceil(Math.random() * 100000)}>
              {line}
              <br />
            </Fragment>
              ))}
        </p>
      )}
      {telephone && (
        <a href={`tel:${telephone}`}>
          <FontAwesomeIcon icon={['fas', 'phone']} />+{telephone}
        </a>
      )}
    </div>
      )}
  </Fragment>
);

export default ContactGroup;
